import type {
  ISmartFilterCheckboxPayload,
  ISmartFilterColumnDataCompare,
  ISmartFilterColumnDataDatePayload,
} from '@modules/smart-filters/types';

export const TRANSLATION_GROUP_SMART_FILTERS = Symbol('smart-filters');

export const RESPONSE_DATE_FORMAT = 'YYYY-MM-DD';

export const DEFAULT_SMART_FILTER_DATE_DATA: ISmartFilterColumnDataDatePayload = {
  start: null,
  end: null,
};
export const DEFAULT_SMART_FILTER_CHECKBOX_DATA: ISmartFilterCheckboxPayload = { value: 'all' };
export const DEFAULT_SMART_FILTER_COMPARE_DATA: ISmartFilterColumnDataCompare = {
  first_condition: {
    first: {
      mark: null,
      value: null,
    },
    second: {
      mark: null,
      value: null,
    },
  },
  second_condition: {
    first: {
      mark: null,
      value: null,
    },
    second: {
      mark: null,
      value: null,
    },
  },
  compare_separator: null,
};
